const notification = 'broadcast/notifications';

export const ENDPOINTS = {
    notification,
    search: `${notification}/search`,
    saveMessage: `${notification}/save`,
    updateMessage: `${notification}/update`,
    deleteMessage: `${notification}/delete`,
    product:"products/navdb-idents",
    userconfigGet: `${notification}/honeywellId`,
    userconfigSave: `${notification}/userconfig`,


    //=============================
    customerDetails: "customer/customers/basic/listing",
    customerSubscription:"user/contact-admin/subscription",
    makeModelDetails: "/inds/getMakeModelDetails",
    hwdSearch:"customer/users/search"
};